// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-tabs";
import "./../bindings/bao-number-box";
import "./../bindings/bao-toggle-buttons";
import "./../bindings/bao-searcher";
import "./../factories/translate-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import BaseSearchPaging2 from "./../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import baoRouter from "../services/bao-router";
import guid from "../factories/guid";
class UniversalField extends BaseSearchPaging2 {
    UniversalFieldId: KnockoutObservable<string>;
    FormName = ko.observable("");
    ConfigurationItemTab: TabPage;
    UniversalFieldDataTypeTab: TabPage;
    UniversalFieldDataSourceTab: TabPage;
    TagAreaTab: TabPage;
    TagShiftBookTab: TabPage;
    UniversalfieldShiftbookTabTab: TabPage;

    /**
     * WorkItemTabUniversalField Tab
     */
    WorkItemTabUniversalFieldTab: TabPage;

    UniversalFieldTypeId: KnockoutObservable<string>;
    Decimals: KnockoutObservable<number>;
    Description: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });
    Description1: KnockoutObservable<string> = ko.observable("");
    Description2: KnockoutObservable<string> = ko.observable("");
    Description3: KnockoutObservable<string> = ko.observable("");
    Description4: KnockoutObservable<string> = ko.observable("");
    Description5: KnockoutObservable<string> = ko.observable("");
    Key: KnockoutObservable<string> = ko.observable("");
    YesNoPositiveText: KnockoutObservable<string>;
    YesNoNegativeText: KnockoutObservable<string>;
    CsvOptionsForUI = ko.observable("");
    CsvOptionsBold = ko.observable(false);
    CsvOptionsUnderlined = ko.observable(false);
    CsvOptionsHeading = ko.observable(false);
    CsvOptionsItalic = ko.observable(false);
    CsvOptionsIsDeselectable = ko.observable(false);
    CopyToNextShift = ko.observable(false);
    CsvOptions = ko.observable("");
    DateTimePickerType = ko.observable();
    YesNoPositiveCss: KnockoutObservable<string>;
    YesNoNegativeCss: KnockoutObservable<string>;
    ColorString = ko.observable("");
    BackgroundColorString = ko.observable("");
    UseThemeColorsFont = ko.observable(false);
    UseThemeColorsBackground = ko.observable(false);
    Alignment = ko.observable("");
    CustomFilterString = ko.observable("");
    ViewModel = ko.observable();
    DateTimePickerValue: KnockoutObservable<string> = ko.observable("");
    DisableSynosetFields = ko.observable(false);
    DisableFinitoFields = ko.observable(false);
    AutoRefresh = ko.observable(false);
    ReadOnly = ko.observable(false);
    HideCaption = ko.observable(false);
    IsWriteTag = ko.observable(false);
    Unit = ko.observable("");
    LimitLower = ko.observable("");
    LimitUpper = ko.observable("");
    Source = ko.observable("");
    SearchObjectKeyName = ko.observable("");
    ConnectorName = ko.observable("");
    ConnectorId = ko.observable(null);
    CopyFromId?: string;
    /**
     * Is the Universalfield Readonly
     * */
    IsReadOnly: KnockoutObservable<boolean>;

    /**
     * Universal Field Client Route
    */
    ClientRoute: KnockoutObservable<string> = ko.observable();

    /**
     * Liefert true wenn der gewählte TagType numerisch ist.
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNumeric = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '1eb0ef5b-07bd-476c-8415-d32931cd6bca');
    });
    /**
     * Liefert true wenn der gewählte TagType YesNo ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsYesNo = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '6c4865b4-3e87-4f64-be09-9e461e88550a');
    });
    /**
     * Liefert true wenn der gewählte TagType Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsCaption = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType nicht Caption ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsNotCaption = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /**
     * Liefert true wenn der gewählte TagType RadioButtons ist
     * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
     */
    TagTypeIsRadioButtons = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && (this.UniversalFieldTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2'
            ||
            this.UniversalFieldTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7'));
    });
    TagTypeNeedsCsvOptions = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && (this.UniversalFieldTypeId() === 'b3f7d21b-56dc-4258-91ba-00f0d64cb2b2' //Radio Buttons
            ||
            this.UniversalFieldTypeId() === '02dd5bf9-f182-4368-917e-dd053ee2f4a7' //Combobox
            ||
            this.UniversalFieldTypeId() === '0fc89eed-9510-4094-a0a8-835cee0a3f24' //=BaoSearcher
        ));
    });
    /**
    * Liefert true wenn der gewählte TagType nicht Platzhalter oder Platzhalter (Linie) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsNotCaptionNorPlaceholder = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" &&
            this.UniversalFieldTypeId() !== '6f5ad806-d399-4bb5-8417-567041b9ecc6'
            && this.UniversalFieldTypeId() !== '80282140-301b-4c8a-8144-e4be45f2de43'
            && this.UniversalFieldTypeId() !== '81c0785b-98b9-45ea-b260-6c6076d5ba3f');
    });
    /***
     * 
     * Hide the datasource fields for the tag type link, placeholder, placeholder line and caption 
     * */
    HideDataSourceFieldsForTagType = ko.pureComputed(() => {
        return !this.TagTypeIsNotCaptionNorPlaceholder() || this.TagTypeIsLink();
    });
    /**
    * Liefert true wenn der gewählte TagType Datum/Zeitauswahl ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsDateTimePicker = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'e2a64241-6766-4159-81d7-257da36327bb');
    });
    /**
    * Liefert true wenn der gewählte TagType TextArea ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsTextArea = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'b453e0de-0f88-4f22-bfff-a0189f6a117b');
    });
    /**
    * Liefert true wenn der gewählte TagType Suchdialog mit Suchobjekt (BaoSearcherWithObject) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsBaoSearcherWithObject = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '8de0ffb8-1250-4322-85ee-2a64c46bbb78');
    });

    /**
    * Liefert true wenn der gewählte TagType Suchdialog mit Suchobjekt/Text (BaoSearcherWithObjectOrText) ist
    * Muss im JS stattfinden, wegen der möglichkeit, am Client den Typ zu ändern
    */
    TagTypeIsBaoSearcherWithObjectOrText = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'c2f274ac-9cd8-4437-8c3a-2bfcd9cfe63a');
    });

    /**
    * Liefert true wenn der gewählte TagType nicht Caption ist
    * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
    */
    TagTypeIsLink = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === 'f1d319e2-7797-4992-93a6-48c3faa64873');
    });

    /**
    * Liefert true wenn der gewählte TagType Checkbox ist
    * Muss im JS stattfinden, wegen der möglichkeit am Client den Typ zu ändern
    */
    TagTypeIsCheckbox = ko.pureComputed(() => {
        return Boolean(typeof this.UniversalFieldTypeId === "function" && this.UniversalFieldTypeId() === '523c8fc3-b4f5-4ac9-8af7-ad883b7f8255');
    });

    DecimalsCalc = ko.pureComputed(() => {
        var decimals = ko.unwrap(this.Decimals);
        return decimals == null ? 0 : decimals;
    });
    PermissionForward = "ForwardTag";
    PermissionBackward = "BackwardTag";
    InitUrl() {
        return "UniversalField/Init";
    }
    /**
     * Loads the Universalfield with the given srcid and changed the id to a new one 
     * @param srcid The sourceid from where to Universalfield gets copied
     * @returns 
     */
    CopyInit(srcid: string) {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        this.CopyFromId = srcid;
        Bao.post(this.InitUrl(), JSON.stringify({ id: srcid }), (model) => {
            ko.map.fromJS(model.Definition, this);
            model.Model.UniversalFieldId = guid();
            model.Model.PrimaryKeyValue = model.Model.UniversalFieldId;
            model.Model.SimpleSearchId = model.Model.UniversalFieldId;
            model.Model.TagId = model.Model.UniversalFieldId;
            model.Model.IsNew = true;
            model.Model.IsDirty = true;
            model.Model.TabName = Bao.Session.GetMessage("newUniversalfield");
            model.Model.InsertDateHtml = "";
            model.Model.InsertBy = null;
            model.Model.UpdateDateHtml = "";
            model.Model.UpdateBy = null;
            ko.map.fromJS(model.Model, this, this.TabPage.DirtyFlag);
            this.TabPage.SessionTabId = this.SessionTabId();
            this.TabPage.ObjectId(model.Model.UniversalFieldId);
            let subscription = this.TabPage.DirtyFlag.subscribe(value => {
                if (value === false) {
                    subscription.dispose();
                    this.TabPage.DirtyFlag(true);
                }
            });
            def.resolve();
        });
        return def.promise();
    }
    init() {
        let srcid = baoRouter.getRouteValue("srcid", this.TabPage);
        let initPromise;
        if (srcid != null) {
            initPromise = this.CopyInit(srcid);
        } else {
            initPromise = super.init()
        }


        return initPromise.then(() => {
            this.setSubscriptions();
            return this.InitTabController();
        }).then(() => {
            this.UniversalFieldDataTypeTab = new TabPage(null);
            this.UniversalFieldDataTypeTab.IsClosable(false);
            this.UniversalFieldDataTypeTab.Url("UniversalFieldDataType");
            this.UniversalFieldDataTypeTab.AutoSelect = true;
            Bao.Session.GetMessage("UniversalFieldDataTypeTabName").then((result) => {
                this.UniversalFieldDataTypeTab.Title(result);
            });
            this.TabController.AddTab(this.UniversalFieldDataTypeTab);
            if (this.DisableSynosetFields() === false) {
                this.UniversalFieldDataSourceTab = new TabPage(null);
                this.UniversalFieldDataSourceTab.IsClosable(false);
                this.UniversalFieldDataSourceTab.Url("UniversalFieldDataSource");
                this.UniversalFieldDataSourceTab.AutoSelect = false;
                Bao.Session.GetMessage("UniversalFieldDataSourceTabName").then((result) => {
                    this.UniversalFieldDataSourceTab.Title(result);
                });
                this.TabController.AddTab(this.UniversalFieldDataSourceTab);
            }
            this.UniversalfieldShiftbookTabTab = new TabPage(null);
            this.UniversalfieldShiftbookTabTab.IsClosable(false);
            this.UniversalfieldShiftbookTabTab.Url("UniversalfieldShiftbookTab");
            this.UniversalfieldShiftbookTabTab.AutoSelect = false;
            this.UniversalfieldShiftbookTabTab.UrlData().CopyFrom = this.CopyFromId;
            this.TabController.AddTab(this.UniversalfieldShiftbookTabTab);

            this.WorkItemTabUniversalFieldTab = new TabPage(null);
            this.WorkItemTabUniversalFieldTab.IsClosable(false);
            this.WorkItemTabUniversalFieldTab.Url("WorkItemTabUniversalField");
            this.WorkItemTabUniversalFieldTab.AutoSelect = false;
            this.TabController.AddTab(this.WorkItemTabUniversalFieldTab);

            $.when(Bao.Session.GetMessage("msgWorkItemTabTitle")).then(() => {
                this.WorkItemTabUniversalFieldTab.Title(Bao.Session.GetMessage("msgWorkItemTabTitle")());
            });

            if (this.DisableSynosetFields() === false) {
                this.ConfigurationItemTab = new TabPage(null);
                this.ConfigurationItemTab.IsClosable(false);
                this.ConfigurationItemTab.Url("UniversalFieldConfigurationItemTab");
                this.ConfigurationItemTab.AutoSelect = false;
                this.TabController.AddTab(this.ConfigurationItemTab);
            }
            if (this.DisableFinitoFields() === false) {
                this.TagShiftBookTab = new TabPage(null);
                this.TagShiftBookTab.IsClosable(false);
                this.TagShiftBookTab.Url("UniversalFieldShiftbook");
                this.TagShiftBookTab.AutoSelect = this.DisableSynosetFields();
                this.TagAreaTab = new TabPage(null);
                this.TagAreaTab.IsClosable(false);
                this.TagAreaTab.Url("UniversalFieldArea");
                this.TagAreaTab.AutoSelect = false;
                this.TabController.AddTab(this.TagShiftBookTab);
                this.TabController.AddTab(this.TagAreaTab);
            }


        }).then(() => {
            this.TabPage.MenuEvents.push(this.Menu.registerEvent((value) => {
                if (this.TabPage.IsActiveTab()) {
                    if (value.ActionKey() === 'UniversalfieldCopy') {
                        this.CopyUniversalfield();
                    }
                }
            }))
        });
    }
    /**
     * Copyies the Current Universalfield 
     * @returns 
     */
    CopyUniversalfield() {
        if (this.IsNew() || this.TabPage.IsDirty()) {
            const msgUniversalfieldNotSaved = Bao.Session.GetMessage("msgUniversalfieldNotSaved");
            new BaoDialog(Bao.Session.ApplicationName, msgUniversalfieldNotSaved, "info");
            return;
        }
        const msgCopyUniversalfield = Bao.Session.GetMessage("msgCopyUniversalField");
        let yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, msgCopyUniversalfield, "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result !== true) {
                return;
            }
            let linkHash = 'universalField/copyfrom/' + this.TabPage.ObjectId()
            baoRouter.setHash(linkHash);
        });
    }

    StringIsNullOrEmpty(pstr) {
        return (typeof pstr === "undefined" || pstr === null || pstr === "");
    }
    CompleteCheck() {
        var isComplete = true;
        if ((this.TagTypeIsNumeric() && (this.Decimals() === null || this.Decimals() === undefined)) ||
            (this.TagTypeIsRadioButtons() && this.StringIsNullOrEmpty(ko.unwrap(this.CsvOptions))) ||
            (this.TagTypeIsYesNo() && (this.StringIsNullOrEmpty(ko.unwrap(this.YesNoPositiveText)) || this.StringIsNullOrEmpty(ko.unwrap(this.YesNoNegativeText)))) ||
            (Bao.Utils.String.IsNullOrEmpty(this.Key()) || Bao.Utils.String.IsNullOrEmpty(this.Description()) || Bao.Utils.String.IsNullOrEmpty(this.UniversalFieldTypeId())))
        {
            isComplete = false;
        }
      
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        // Nicht mehr als 100 Zeilen für die TextArea  
        if (this.TagTypeIsTextArea() && isComplete) {
            let value = parseInt(ko.unwrap(this.CsvOptions));
            if (value != null && (value < 1 || value > 100 || isNaN(value))) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgLessRows"), "info");
                isComplete = false;
            }
            
        }
        return isComplete;
    }
    ;
    HandleSaveResponse(response): JQueryPromise<void> {
        var def = $.Deferred<void>();

        if (response.Message != undefined && response.Message != null) {
            new BaoDialog(Bao.Session.ApplicationName, response.Message, "info");
            this.TabPage.IsLoading(false);
            def.resolve();
        }
        else {
            super.HandleSaveResponse(response).done(() => {
                def.resolve();
            });
        }
        return def.promise();
    }

    MinimizeEntity() {
        let minimizedEntity = super.MinimizeEntity();
        if (this.TagTypeIsCaption()) {
            let options = [];
            if (this.CsvOptionsBold()) {
                options.push("Bold");
            }
            if (this.CsvOptionsUnderlined()) {
                options.push("Underlined");
            }
            if (this.CsvOptionsHeading()) {
                options.push("Heading");
            }
            if (this.CsvOptionsItalic()) {
                options.push("Italic");
            }
            minimizedEntity.CsvOptions = options.join(",");
        }
        else if (this.TagTypeIsDateTimePicker()) {
            minimizedEntity.CsvOptions = this.DateTimePickerValue();
        }
        else if (this.TagTypeIsYesNo()) {
            let options = [];
            if (this.CsvOptionsIsDeselectable()) {
                options.push("IsDeselectable");
            }
            minimizedEntity.CsvOptions = options.join(",");
        }
        return minimizedEntity;
    }
    private setSubscriptions() {
        this.UniversalFieldTypeId.subscribe((newVal) => {
            this.resetDataTypeTabFieldValue(newVal);
            if (this.HideDataSourceFieldsForTagType()) {
                this.ConnectorId(null);
                this.ConnectorName("");
            }
        });
    }
    Translate() {
        var translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }
    //Reset the values of the fields
    resetDataTypeTabFieldValue = (newValue) => {
        if (newValue === '1eb0ef5b-07bd-476c-8415-d32931cd6bca') {
            this.Decimals(0);
        }
        else if (this.Decimals) {
            this.Decimals(null);
        }
        this.YesNoPositiveText("");
        this.YesNoNegativeText("");

        this.CsvOptionsBold(false);
        this.CsvOptionsUnderlined(false);
        this.CsvOptionsHeading(false);
        this.CsvOptionsItalic(false);
        this.CsvOptionsIsDeselectable(false);

        this.CsvOptions("");
        this.Alignment("")
        this.YesNoPositiveCss("");
        this.YesNoNegativeCss("");
        this.ColorString("");
        this.BackgroundColorString("");

        this.CustomFilterString("");
        this.Unit("");
        this.LimitLower("");
        this.LimitUpper("");
        this.Source("");
        this.DateTimePickerValue("");
        this.SearchObjectKeyName()
    }
}
export default UniversalField;